import { render, staticRenderFns } from "./JsFooter.vue?vue&type=template&id=217a7e2f&scoped=true&"
var script = {}
import style0 from "./JsFooter.vue?vue&type=style&index=0&id=217a7e2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217a7e2f",
  null
  
)

export default component.exports